import { useState } from "react";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import FormGroup from "./FormGroup.js";
import ButtonGrid from "./ButtonGrid.js";

export default function JoinModal (props)
{
    const [validated, setValidated] = useState(false);

    const [code, setCode] = useState(props.code);

    const value = code.length < 3 ? code : code.substring(0, 3) + " " + code.substring(3, code.length);

    function handleCodeChange (e)
    {
	let nextValue = e.target.value;
	if (nextValue + " " === value) nextValue = nextValue.substring(0, nextValue.length-1);

	let nextCode = nextValue.replace(/[^a-zA-Z0-9]+/g, "").toUpperCase();
	if (nextCode.length > 6) nextCode = nextCode.substring(0, 6);
	setCode(nextCode);
    }

    /* function hide ()
     * {
       props.hide();
       setCode("");
       setValidated(false);
     * }
     * 
     * function handleHide (e) { hide(); } */

    function handleSubmit (e)
    {
	e.preventDefault();
	if (e.target.checkValidity()) {
	    props.submit({ code });
	    //setCode("");
	    setValidated(false);
	    //hide();
	}

	else setValidated(true);
    }

    return (
	<Modal
	    backdrop="static"
            keyboard={false}
	    show={props.show}
	    centered
	    size="sm"
	>
	    <Modal.Header>
		<Modal.Title>Rejoindre une SIM</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		<Form
		    id="joinForm"
			noValidate validated={validated}
			onSubmit={handleSubmit}
		>
		    <FormGroup sm={5} formID="joinForm" controlId="joinForm.code" label="Code SIM">
			<Form.Control
			    type="text"
			    required
			    autoComplete="off"
			    autoFocus
			    value={value}
			    onChange={handleCodeChange}
			/>
		    </FormGroup>
		</Form>
	    </Modal.Body>
	    
	    <Modal.Footer>
		<ButtonGrid>
		    <ButtonGrid.Left>
		    </ButtonGrid.Left>
		    <ButtonGrid.Right>
			<Button variant="primary" size="md" type="submit" form="joinForm">Se connecter</Button>
		    </ButtonGrid.Right>
		</ButtonGrid>
	    </Modal.Footer>
	</Modal>
    );
}
